import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes } from '@angular/router';

import { SharedModule } from '@app/shared';
import { AuthGuard } from '@app/core/auth';
import { WxrlRulesListComponent } from './pages/wxrl-rules-list/wxrl-rules-list.component';
import { WxrlRuleDetailComponent } from './pages/wxrl-rule-detail/wxrl-rule-detail.component';
import { WxrlRuleLogsComponent } from './components/wxrl-rule-logs/wxrl-rule-logs.component';
import { rbac } from '@app/shared/rbac';

const securedRoute: Route = {
  canActivate: [AuthGuard],
};

const adminRoute: Route = {
  ...securedRoute,
  data: {},
};

const routes: Routes = [
  {
    path: 'wxrl',
    ...securedRoute,
    children: [
      {
        path: 'rules/:id',
        component: WxrlRuleDetailComponent,
        canActivate: [AuthGuard],
        data: {
          profiles: [
            rbac.profiles.WRULES_ADMIN,
            rbac.profiles.WRULES_USER,
            rbac.profiles.WRULES_READER,
          ],
        },
      },
      {
        path: 'rules',
        component: WxrlRulesListComponent,
        pathMatch: 'full',
        canActivate: [AuthGuard],
        data: {
          profiles: [
            rbac.profiles.WRULES_ADMIN,
            rbac.profiles.WRULES_USER,
            rbac.profiles.WRULES_READER,
          ],
        },
      },
      {
        path: 'logs',
        component: WxrlRuleLogsComponent,
        canActivate: [AuthGuard],
        data: {
          profiles: [
            rbac.profiles.WRULES_ADMIN,
            rbac.profiles.WRULES_USER,
            rbac.profiles.WRULES_READER,
          ],
        },
      },
    ],
  },
];

@NgModule({
  imports: [SharedModule, RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WxrlRoutingModule {}
